import {
  IshipAddres,
  ShipAddressCreateInput,
  ShipAddressUpdateInput,
  ShippingFieldErrors,
} from '../components/interfaces';

const requiredShippingFields: Array<keyof Pick<
  IshipAddres,
  'firstName' | 'lastName' | 'addressLine1' | 'city' | 'postcode' | 'telephone' | 'country'
>> = ['firstName', 'lastName', 'addressLine1', 'city', 'postcode', 'telephone', 'country'];

const guestEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const getRequiredShippingFieldErrors = (
  data: Partial<IshipAddres>
): ShippingFieldErrors => {
  const errors: ShippingFieldErrors = {};

  requiredShippingFields.forEach((field) => {
    const value = data[field];
    errors[field] = !value || typeof value !== 'string' || !value.trim();
  });

  return errors;
};

export const hasShippingFieldErrors = (errors: ShippingFieldErrors) =>
  Object.values(errors).some(Boolean);

export const buildUpdatedShippingData = (
  userInfo: IshipAddres,
  shipping?: IshipAddres | null
): ShipAddressUpdateInput => ({
  firstName: userInfo.firstName ?? shipping?.firstName,
  lastName: userInfo.lastName ?? shipping?.lastName,
  addressLine1: userInfo.addressLine1 ?? shipping?.addressLine1,
  addressLine2: userInfo.addressLine2 ?? shipping?.addressLine2,
  city: userInfo.city ?? shipping?.city,
  postcode: userInfo.postcode ?? shipping?.postcode,
  telephone: userInfo.telephone ?? shipping?.telephone,
  country: userInfo.country ?? shipping?.country,
  province: userInfo.province ?? shipping?.province,
  phoneCode: userInfo.phoneCode ?? shipping?.phoneCode,
  emoji: userInfo.emoji ?? shipping?.emoji,
  useAddressForBilling: userInfo.useAddressForBilling ?? shipping?.useAddressForBilling,
});

export const buildCreateShippingAddressData = (
  updatedData: ShipAddressUpdateInput
): ShipAddressCreateInput => ({
  firstName: String(updatedData.firstName || ''),
  lastName: String(updatedData.lastName || ''),
  addressLine1: String(updatedData.addressLine1 || ''),
  addressLine2: updatedData.addressLine2 || undefined,
  city: String(updatedData.city || ''),
  postcode: String(updatedData.postcode || ''),
  telephone: String(updatedData.telephone || ''),
  country: String(updatedData.country || ''),
  province: updatedData.province || undefined,
  phoneCode: updatedData.phoneCode || undefined,
  emoji: updatedData.emoji || undefined,
  useAddressForBilling: Boolean(updatedData.useAddressForBilling),
});

export const getNormalizedGuestEmail = (email?: string) =>
  String(email || '').trim().toLowerCase();

export const isValidGuestEmail = (email?: string) =>
  guestEmailPattern.test(getNormalizedGuestEmail(email));

export const getAddressVerificationErrorFields = (): ShippingFieldErrors => ({
  addressLine1: true,
  city: true,
  postcode: true,
  country: true,
});

export const isGuestCheckoutRoute = (userId: string | undefined, pathname: string) =>
  !userId && pathname === '/cart/checkout';
